<template>
  <section>
  </section>
</template>

<script>
    export default {
        name: "Intro",
        data() {
            return {
                authenticated: window.authenticated,
                HomeScreenAutoPlay: window.HomeScreenAutoPlay
            };
        }
    }
</script>

